module.exports = __webpack_public_path__ + "static/media/hero.cb795127.webp";